import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01df6ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fallback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", null, [
      _createTextVNode("Fallback tile - did not find alias: "),
      _createElementVNode("b", null, _toDisplayString(_ctx.alias), 1)
    ]),
    _createElementVNode("pre", null, _toDisplayString(_ctx.content), 1)
  ]))
}